module.exports = __webpack_public_path__ + "img/incomeBlue.8d9b54ac.png";